import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatDecimal, NOT_AVAILABLE_DEFAULT_STR } from '@bingads-webui-campaign/recommendation-core';

export class MissedConversionColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'MissedConversions',
      property: 'MissedConversions',
      title: i18n.getString('Details_View_Missed_Conversion') || 'Weekly missed conversions',
      bodyClasses: ['grid-column-goalName', 'actionable'],
      colClasses: ['col-number'],
      sortable: 'EstimatedIncreaseInConversionsInt',
      type: 'number',
    });
    this.i18n = i18n;
  }

  template({ value: { EstimatedIncreaseInConversionsInt } }) {
    const { i18n } = this;
    return _.isNumber(EstimatedIncreaseInConversionsInt) ?
      formatDecimal(EstimatedIncreaseInConversionsInt, i18n) : NOT_AVAILABLE_DEFAULT_STR;
  }

  get property() {
    return {
      get: _.identity,
      property: 'MissedConversions',
    };
  }
}
